module.exports = __webpack_public_path__ + "static/media/starshipit2_preview.1396d3f0.jpg";